import React, { useEffect, useState, useRef, createRef } from "react";
import TwoWayReportNav from "./TwoWayReportNav";
import TwoWayFirstSec from "./TwoWayFirstSec";
import TwoWayOverallAnalys from "./TwoWayOverallAnalys";
import TwoWaySkill from "./TwoWaySkill";
import VideoClips from "./VideoClips";
import Integrity from "./Integrity";
import ActionItem from "./ActionItem";
import { reportGetApi, reportGetShotImgApi } from "../../../api";
import Loader from "../../Loader";
import TranscriptSection from "./TranscriptSection";
import PersonalityAnalysis from "./PersonalityAnalysis";

function TwoWayReport({ auth, interviewId, interviewType, loginQuery }) {
  const [switchSystem, setSwitchSystem] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imgShot, setImgShot] = useState();
  const [interviewData, setInterviewData] = useState({});
  const [config, setConfig] = useState(null);
  const [selectedSkillId, setSelectedSkillId] = useState(null);

  // Create a ref object to hold refs for each skill in TwoWaySkill.
  const skillRefs = useRef({});

  // Update refs when the skills change
  useEffect(() => {
    const skills = interviewData?.interviewAnalysis?.skillAnalysis || [];
    const refs = {};
    skills.forEach((skill) => {
      refs[skill.candidateInterviewSkillId] = createRef();
    });
    skillRefs.current = refs;
  }, [interviewData?.interviewAnalysis?.skillAnalysis]);

  // When a skill is clicked, update the selected skill ID.
  const handleSkillClick = (skillId) => {
    setSelectedSkillId(skillId);
    const ref = skillRefs.current[skillId];
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const getReport = async () => {
    const url = `${reportGetApi}?interviewId=${interviewId}`;
    // let url
    try {
      setLoading(true);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      if (result.resultStatusInfo.resultCode.toLowerCase() === "success") {
        setInterviewData(result.data);
        setConfig(result.data?.configuration);
      }
    } catch (err) {
      console.error("Fetch error: ", err);
    } finally {
      setLoading(false);
    }
  };

  const imgGet = async () => {
    const url = `${reportGetShotImgApi}?interviewId=${interviewId}&interviewType=${interviewType}&isSnapshotRequired=true&isScreenshotRequired=true&snapshotCount=5&screenshotCount=5`;

    try {
      // Optional: show loading state
      // setLoading(true);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      // console.log(result)
      if (result.resultStatusInfo.resultCode.toLowerCase() === "success") {
        // console.
        setImgShot(result.data);
        // console.log(result.data);
      }
    } catch (err) {
      console.error("Fetch error: ", err);
    } finally {
      // Optional: hide loading state
      // setLoading(false);
    }
  };

  useEffect(() => {
    imgGet();
    getReport();
  }, []);
  return (
    <>
      {loading && <Loader />}
      {interviewData?.candidateName && (
        <div className="report-container max-w-[1140px] shadow-2xl m-auto">
          <TwoWayReportNav
            switchSystem={switchSystem}
            setSwitchSystem={setSwitchSystem}
            auth={auth}
            interviewId={interviewId}
            config={config}
          />
          <div className="print:px-6 md:px-6 sm:px-3 px-2 py-3">
            <TwoWayFirstSec interviewData={interviewData} />
            <TwoWayOverallAnalys
              switchSystem={switchSystem}
              overallAnalysisData={
                interviewData?.interviewAnalysis?.overallAnalysis
              }
              skillAnalysisDataObj={
                interviewData?.interviewAnalysis?.skillAnalysis
              }
              onSkillClick={handleSkillClick}
              auth={auth}
              interviewId={interviewId}
              interviewType={interviewType}
              getReport={getReport}
            />
            <TwoWaySkill
              skillRefs={skillRefs.current}
              switchSystem={switchSystem}
              skillAnalysisDataObj={
                interviewData?.interviewAnalysis?.skillAnalysis
              }
              auth={auth}
              interviewId={interviewId}
              interviewType={interviewType}
              getReport={getReport}
            />
            <VideoClips
              config={config}
              imgShot={imgShot}
              auth={auth}
              loginQuery={loginQuery}
            />
            <TranscriptSection loginQuery={loginQuery} />
            {interviewData?.interviewAnalysis?.integrityInfo && (
              <Integrity
                config={config}
                integrityInfo={interviewData?.interviewAnalysis?.integrityInfo}
                loginQuery={loginQuery}
              />
            )}
            <PersonalityAnalysis
              mbtiData={interviewData?.mbtiAnalysis}
              loginQuery={loginQuery}
            />
            <ActionItem
              switchSystem={switchSystem}
              actionableItemsObj={
                interviewData?.interviewAnalysis?.actionableItems
              }
              auth={auth}
              interviewId={interviewId}
              interviewType={interviewType}
              getReport={getReport}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default TwoWayReport;
